import "@components/alert_tags.scss";
import { Tag, useTagOverflow } from "@sprout/tag";
import Tooltip from "@/sprout/tooltip";

interface Props {
  values: string[];
}

const AlertTags = ({ values }: Props) => {
  const [containerRef, visibleTags, hiddenTags] = useTagOverflow(values, (tag: string) => (
    <Tag label={tag} className="tag-item" />
  ));

  return (
    <div className="alert-tags tag-overflow" ref={containerRef}>
      {visibleTags.map((value) => (
        <Tag key={value} label={value} className="tag-item" />
      ))}
      {hiddenTags.length > 0 && (
        <Tooltip text={hiddenTags.join(", ")}>
          <div className="more-tags">+{hiddenTags.length}</div>
        </Tooltip>
      )}
    </div>
  );
};

export default AlertTags;
